import {filtroExiste} from '../../util/filtros';
import {
  ADICIONAR_FILTRO_INTERESSADOS_PROMOCAO, ALTERAR_REGISTROS_POR_PAGINA_INTERESSADO,
  BUSCAR_INTERESSADOS_PROMOCAO, DETERMINAR_PAGINA_ATUAL_INTERESSADO,
  LIMPAR_FILTRO_INTERESSADOS_PROMOCAO,
  LISTAR_FILTROS_INTERESSADOS_PROMOCAO,
  REMOVER_FILTRO_INTERESSADOS_PROMOCAO
} from '../../actions/interessado-promocao/usuariosPromocaoActions';

const initialState ={
  interessados: [],
  filtrosAdicionados:[],
  filtros:[],
  registrosPorPagina: 10,
  paginaAtual: 1,
  total:0,
  filtrosInteressadosPromocao: []
  
};

export default function reducerInteressados (state = initialState, action) {
  switch (action.type) {
    case BUSCAR_INTERESSADOS_PROMOCAO: {
      const interessados = action.payload.data;
      if (interessados) {
        return {
          ...state,
          interessados: interessados.interessadosRecebimentoPromocoes,
          total: interessados.total
        }
      }
      return []
    }
  
    case ADICIONAR_FILTRO_INTERESSADOS_PROMOCAO: {
      if (!filtroExiste(state.filtrosAdicionados, action.payload)) {
        return {
          ...state,
          filtrosAdicionados: state.filtrosAdicionados.concat(action.payload)
        }
      }
      return state
    }
  
    case REMOVER_FILTRO_INTERESSADOS_PROMOCAO: {
      const copia = state.filtrosAdicionados
      return {
        ...state,
        filtrosAdicionados: copia.filter(filtro => filtro.chave !== action.payload.chave || filtro.valor !== action.payload.valor)
      }
    }
  
    case LIMPAR_FILTRO_INTERESSADOS_PROMOCAO: {
      return {
        ...state,
        filtrosAdicionados: []
      }
    }
  
    case LISTAR_FILTROS_INTERESSADOS_PROMOCAO: {
      return {
        ...state,
        filtrosInteressadosPromocao: action.payload.data
      }
    }
    case DETERMINAR_PAGINA_ATUAL_INTERESSADO: {
      return {
        ...state,
        paginaAtual: action.payload
      }
    }
    case ALTERAR_REGISTROS_POR_PAGINA_INTERESSADO:{
      return {
        ...state,
        registrosPorPagina: action.payload
      }
    }

    default: {
      return state
    }
  }
}
